export type AdminView =
  | "libraries"
  | "claims"
  | "requests"
  | "support"
  | "sources"
  | "refreshTiers"
  | "queue"
  | "runs"
  | "usage"
  | "limits"
  | "logs"
  | "notifications"
  | "dead"
  | "system";

const routes: Record<AdminView, string> = {
  libraries: "/libraries",
  claims: "/claims",
  requests: "/requests",
  support: "/support",
  sources: "/sources",
  refreshTiers: "/refresh-tiers",
  queue: "/queue",
  runs: "/runs",
  usage: "/usage",
  limits: "/limits",
  logs: "/logs",
  notifications: "/notifications",
  dead: "/dead",
  system: "/system"
};

export function routeForView(view: AdminView) {
  return routes[view];
}

export function viewFromPathname(pathname: string): AdminView {
  const path = normalizePathname(pathname);
  if (path === "/" || path === "") return "libraries";
  const direct = Object.entries(routes).find(([, route]) => route === path);
  if (direct) return direct[0] as AdminView;
  if (path.startsWith("/admin/")) {
    const adminPath = path.slice("/admin".length);
    const adminMatch = Object.entries(routes).find(([, route]) => route === adminPath);
    if (adminMatch) return adminMatch[0] as AdminView;
  }
  return "libraries";
}

export function normalizePathname(pathname: string) {
  const path = pathname.replace(/\/+$/, "");
  return path || "/";
}

export function adminViewLabel(view: AdminView) {
  return view
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[-_]/g, " ")
    .replace(/^./, (char) => char.toUpperCase());
}
